type Props = {
  text: string;
  icon?: React.ReactNode;
  onClick: () => void;
  block?: boolean;
};

export const TopButton = ({ text, icon, onClick }: Props) => {
  return (
    <button
      className="flex w-full items-center justify-center rounded-2xl font-poppins flex-col font-normal py-3 px-4 gap-2 text-base text-greyscale-100 bg-greyscale-800"
      onClick={onClick}
    >
      {icon}
      {text}
    </button>
  );
};
